module.exports = __webpack_public_path__ + "img/pic17.e1d639f0.png";